module.exports = __webpack_public_path__ + "static/media/operating_system.1ffb2d13.svg";